// src/components/SearchResults.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './header';

const SearchResults = () => {
  const location = useLocation();
  const { results, query, cities } = location.state || { results: [], query: '', cities: [] };

  return (
    <div>
      <Header />
      <div className="container py-4">
        <h2>Search Results</h2>
        <p>
          Showing results for "{query}"
          {cities.length > 0 && ` in ${cities.join(', ')}`}
        </p>

        <div className="row">
          {results.map((result) => (
            <div key={`${result.type}-${result.id}`} className="col-md-6 mb-4">
              <div className="card">
                <div className="card-body">
                  <span className="badge bg-secondary mb-2">
                    {result.type === 'store' ? 'Store' : 'Product'}
                  </span>
                  <h5 className="card-title">{result.title}</h5>
                  <p className="card-text">{result.description}</p>
                  {result.type === 'product' && (
                    <p className="card-text">
                      <strong>Price:</strong> ${result.price}
                    </p>
                  )}
                  <p className="card-text">
                    <small className="text-muted">Location: {result.city}</small>
                  </p>
                </div>
              </div>
            </div>
          ))}
          
          {results.length === 0 && (
            <div className="col">
              <p>No results found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchResults;